export const PATIENT_PROFILE = 'PATIENT_PROFILE';

export default PATIENT_PROFILE;
